// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lr-0";
export var fileList = "_lr-2";
export var removeFileButton = "_lr-1";